import React, { useEffect } from "react";
import { useUsers } from "../context/UsersContext";
import UserList from "../components/FromUsers/UserList";
import Sidebar from "../components/Sidebar";
import { useAuth } from "../context/AuthContext";
import HeaderPage from "../components/HeaderPage";

const StudentsPage = () => {
  const { user } = useAuth(); // Obtener el usuario autenticado
  const { students, fetchStudentsByDirector, loading, fetchStudents } = useUsers();

  useEffect(() => {
    if (user.rol_id === 2) {
      // Si el usuario es un profesor, cargar solo sus estudiantes
      fetchStudentsByDirector(user.id);
    } else {
      fetchStudents(); // Administradores o roles superiores pueden ver todos los estudiantes
    }
  }, [user]);

  return (
    <div className="flex min-h-screen ">
      {/* Sidebar */}
      <Sidebar />
        
      {/* Contenido principal */}
      <div className="flex-1  p-6 overflow-y-auto">
      <div>
        <HeaderPage />
        </div>
        {loading ? (
          <p className="text-center text-xl font-semibold">Cargando estudiantes...</p>
        ) : (
          <UserList users={students} type="students" />
        )}
      </div>
    </div>
  );
};

export default StudentsPage;

